var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2Logout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1891 9.0169H5.1V10.5686H18.1891L15.9532 12.8704L17.0335 13.9824L21.1034 9.79277L17.0335 5.60311L15.9532 6.71518L18.1891 9.0169ZM12.8276 7.46518V7.5169H3.72414V12.0686H12.8276V12.1204H14.069V17.5514C14.069 17.9781 13.9214 18.3434 13.6262 18.6473C13.331 18.9512 12.9761 19.1031 12.5616 19.1031H1.50741C1.09286 19.1031 0.737992 18.9512 0.442796 18.6473C0.1476 18.3434 0 17.9781 0 17.5514V2.03415C0 1.60742 0.1476 1.24212 0.442796 0.93824C0.737992 0.634363 1.09286 0.482422 1.50741 0.482422H12.5616C12.9761 0.482422 13.331 0.634363 13.6262 0.93824C13.9214 1.24212 14.069 1.60742 14.069 2.03415V7.46518H12.8276Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2Logout);
export default __webpack_public_path__ + "static/media/v2-logout.16286f3699dcfb8b60b92c63241726a1.svg";
export { ForwardRef as ReactComponent };